import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

// Material-UI
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { IconButton, InputAdornment, makeStyles } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
// Gambar
import GambarLogin from "../../../assets/image/backgroundLogin.jpg";
// Components
import Copyright from "../components/Copyright";

//service
import registrasiService from "../services/registrasiService"

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    // backgroundImage: 'url(https://garudanews.id/wp-content/uploads/2019/03/relawan-pmi.jpg)',
    backgroundImage: `url(${GambarLogin})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(10, 4, 0, 4),
    paddingTop: theme.spacing(10),
    display: "flex",
    flexDirection: "column",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  captha: {
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0),
  },
}));

const BackgroundLogin = ({ classes }) => {
  return (
    <Grid item xs={false} sm={4} md={7} className={classes.image} component="section"/>
  );
};

const FormLogin = ({ classes }) => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();

  const onSubmit = async(data) => {
    try {
      let bodyRequest = {
        email: data.email,
        password: data.password,
        token_daftar: classes.daftarToken
      };
  
      if (data.password !== data.password2) {
        return Swal.fire({
          icon: "error",
          title: "Password Tidak Sama!",
          text: "Coba ketik pelan - pelan passwordnya ^_^",
        });
      }
  
      let postDaftar = await registrasiService.storeRegistrasi(bodyRequest);

      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Mendaftar!",
          text: postDaftar.data.message,
        }),
        history.push('/')
      )
    } catch(e) {
      console.error("error: ", e)
      return Swal.fire({
        icon: "error",
        title: "Gagal Mendaftar!",
        text: e.message,
      });
    }



    /*
    if (data.email === "user1@unj.ac.id" && data.password === data.password2) {
      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Mendaftar!",
          text: "Pendaftaran akun sukses, silahkan login ^_^",
        }),
        history.push('/')
      );
    } else if (
      data.email === "user1@unj.ac.id" &&
      data.password !== data.password2
    ) {
      return Swal.fire({
        icon: "error",
        title: "Password Tidak Sama!",
        text: "Coba ketik pelan - pelan passwordnya ^_^",
      });
    } else {
      return Swal.fire({
        icon: "error",
        title: "Gagal Mendaftar!",
        text: "Email tidak bisa digunakan T_T",
      });
    } */
  };

  // Show Password
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  // Show Konfirmasi Password
  const [showKonfirmasiPassword, setShowKonfirmasiPassword] = useState(false);
  const handleClickShowKonfirmasiPassword = () => setShowKonfirmasiPassword(!showKonfirmasiPassword);
  const handleMouseDownKonfirmasiPassword = () => setShowKonfirmasiPassword(!showKonfirmasiPassword);

  return (
    <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
      <div className={classes.paper}>
        <Typography component="h1" variant="h5" align="center">
          REGISTRASI AKUN
        </Typography>
        <form
          className={classes.form}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="email"
            name="email"
            inputRef={register({ required: true })}
            label="Email"
            type="email"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            autoFocus
          />
          <TextField
            id="password"
            name="password"
            inputRef={register({ required: true })}
            label="Password"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            id="password2"
            name="password2"
            inputRef={register({ required: true })}
            label="Konfirmasi Password"
            type={showKonfirmasiPassword ? "text" : "password"}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowKonfirmasiPassword}
                    onMouseDown={handleMouseDownKonfirmasiPassword}
                  >
                    {showKonfirmasiPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Button
            className={classes.submit}
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            fullWidth
          >
            {"DAFTAR"}
          </Button>
          <Box mt={3}>
            <Copyright />
          </Box>
        </form>
      </div>
    </Grid>
  );
};

const Registrasi = () => {
  const classes = useStyle();
  var [showDaftarToken, setDaftarToken] = useState("");

  useEffect(() => {
    registrasiService.getDaftarToken()
    .then((response) => {
      setDaftarToken(response.data.data.tokenJWT_daftar)
    })
    .catch((error) => {
      console.error("error: ", error)
      return Swal.fire({
        icon: "error",
        title: "Gagal Mendaftar!",
        text: error.message,
      });
    })
  }, [setDaftarToken]);

  classes.daftarToken = showDaftarToken;

  return (
    <section id="registrasi-akun">
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <FormLogin classes={classes} />
        <BackgroundLogin classes={classes} />
      </Grid>
    </section>
  );
};
export default Registrasi;
